import { useMemo } from "react";
import { useSearchParams } from "react-router";
import { SortDescriptor } from "react-aria-components";

import { getSearchQuery } from "components/SearchInput/helpers";
import { ApiKey } from "types/generated";

import { sortApiKeys } from "./sortApiKeys";

export const useFilteredApiKeys = (apiKeys: ApiKey[], sortDescriptor: SortDescriptor) => {
  const [searchParams] = useSearchParams();
  const searchInput = getSearchQuery(searchParams);

  return useMemo(() => {
    let filteredApiKeys = [...apiKeys];

    // Apply search filter if exists
    if (searchInput) {
      const searchInputLower = searchInput.toLowerCase();

      filteredApiKeys = filteredApiKeys.filter((apiKey) => {
        const name = apiKey.name?.toLowerCase() || "";
        const creator = apiKey.creator?.toLowerCase() || "";
        const id = apiKey.id?.toLowerCase() || "";

        return (
          name.includes(searchInputLower) ||
          creator.includes(searchInputLower) ||
          id.includes(searchInputLower)
        );
      });
    }

    // Apply sorting
    filteredApiKeys = sortApiKeys(filteredApiKeys, sortDescriptor);

    return filteredApiKeys;
  }, [apiKeys, searchInput, sortDescriptor]);
};
